<template>
  <div>
    <!-- <LandSolutionBannerPro></LandSolutionBannerPro> -->
    <LandBanner :bannerUrl="bannerUrl" :bannerTitle="bannerTitle" :bannerText="bannerText"></LandBanner>
    <div class="solution-video">
      <div class="solution-video-title">施工方数字新成本解决方案</div>
      <div class="solution-video-text">面向企业精细化管理的诉求，数字新成本解决方案以企业成本数据积累与应用的闭环打通为核心，赋能企业实现数据资产化、作业高效化、决策智能化
      </div>
      <video-play
        v-if="showVideo"
        :src="videoList.fileUrl"
        @close="showVideo = false"
      ></video-play>
      <div
        class="solution-video-url"
        v-if="videoList.fileType==='video'"
        @mouseover="isMask=true"
        @mouseleave="isMask=false"
      >
        <div id="poster">
          <div
            class="video-img"
            style="position: relative;width: 868px;height: 444px;"
          >
            <img
              :src="videoImg"
              style="border-radius: 17px;width:100%;height:100%"
            />
          </div>
          <div
            class="video-img-mask"
            v-show="isMask"
            style="position: relative;width: 868px;height: 444px;margin-top:-444px;
            background: #1F1F1F;
            border-radius: 17px;
            opacity: 0.72;"
          >
          </div>
          <div
            class="video-play"
            @click="onPlay(videoList.clientGroup)"
          ><img :src="playImg" /></div>
        </div>
      </div>
      <div
        class="solution-video-url"
        v-else-if="videoList.fileType==='image'"
      >
        <img
          :src="videoList.fileUrl"
          style="border-radius: 17px;width: 868px; height: 444px;"
        />
      </div>
    </div>
    <div class="solution-architecture">
      <div class="solution-architecture-title">施工方-方案架构</div>
      <div class="solution-architecture-img">
        <img :src="architectureUrl">
      </div>
    </div>
    <div class="solution-value">
      <div class="solution-value-title">方案核心价值</div>
      <div class="solution-value-img">
        <div class="value-img-top">
          <div class="value-img-title"><img :src="value1"></div>
          <div class="value-img-text">
            <div style="padding-top:61px;">数据积累无感化<br>
              价格更新动态化</div>
          </div>
        </div>
        <div class="value-img-top">
          <div class="value-img-title"><img :src="value2"></div>
          <div
            class="value-img-text"
            style="background:linear-gradient(141deg, #9595FF 0%, #5C5CFF 100%);"
          >
            <div style="padding-top:61px;">业务数据一体化<br>
              专业经验组织化</div>
          </div>
        </div>
        <div class="value-img-top">
          <div class="value-img-title"><img :src="value3"></div>
          <div
            class="value-img-text"
            style="background:linear-gradient(141deg, #54E1F5 0%, #2AC0E7 100%);"
          >
            <div style="padding-top:61px;">成本作业在线化<br>作业编制协同化</div>
          </div>
        </div>
        <div class="value-img-top">
          <div class="value-img-title"><img :src="value4"></div>
          <div
            class="value-img-text"
            style="background:linear-gradient(140deg, #FFDC8E 0%, #FFB655 100%);"
          >
            <div style="padding-top:61px;">经营分析可视化<br>成本管控智能化</div>
          </div>
        </div>
      </div>
      <div class="solution-value-text">
        <div class="value-text">
          <div class="value-text-left"><img :src="value5">
            <div class="text-left">管理层价值</div>
          </div>
          <div class="value-text-right">
            <div class="text-right-title">数据驱动的成本精细化管理</div>
            <div class="text-right-text">
              <ul>
                <li>建立数据标准，激活数据资产</li>
                <li>统一作业平台，提升组织效能</li>
                <li>辅助高效决策，收支分析零投入，经营情况实时可见</li>
              </ul>
            </div>
          </div>
        </div>
        <div class="value-text">
          <div class="value-text-left"><img
              :src="value6"
              style="margin-top:42px;
          margin-left:41px;"
            >
            <div
              class="text-left"
              style="margin-top:-7px;"
            >岗位层价值</div>
          </div>
          <div class="value-text-right">
            <div class="text-right-title">让成本作业高效精准有据可依</div>
            <div class="text-right-text">
              <ul>
                <li>提高作业效率<span style="color:#FF9710;margin-left: 15px;">5-10</span>&nbsp;倍</li>
                <li>保障作业质量<span style="color:#FF9811;margin-left: 15px;">0</span>&nbsp;失误</li>
                <li>降低从业门槛<span style="color:#FE9713;margin-left: 15px;">1</span>&nbsp;年精通成本业务</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="solution-case">
      <LandSolutionCasePro></LandSolutionCasePro>
    </div>
    <LandHomePurchase></LandHomePurchase>
  </div>
</template>

<script>
// import LandSolutionBannerPro from './components/LandSolutionBannerPro.vue'
import LandSolutionCasePro from './components/LandSolutionCasePro.vue'
import LandBanner from '../../../../../components/LandBanner.vue'
import LandHomePurchase from '../land-home/components/LandHomePurchase.vue'
import VideoPlay from './components/VideoPlay/Index.vue'

import { getVideoList } from '@/api/landing'
const videoImg1 = require('../../../../../assets/images/land-page/land-home/videoMask2.jpg')
const architectureUrl = require('@/assets/images/land-page/land-home/contractor2.png')
const playImg = require('@/assets/images/svg/play.svg')
const value1 = require('@/assets/images/svg/value1.svg')
const value2 = require('@/assets/images/svg/value2.svg')
const value3 = require('@/assets/images/svg/value3.svg')
const value4 = require('@/assets/images/svg/value4.svg')
const value5 = require('@/assets/images/svg/value5.svg')
const value6 = require('@/assets/images/svg/value6.svg')
const bannerUrl = require('../../../../../assets/images/land-page/land-home/production-banner2.jpg')
export default {
  name: 'landSolution',
  created () { },
  mounted () {
    // this.closeVideo()
    this.getList()
    // this.computeVideoSize()
  },
  components: {
    // LandSolutionBannerPro,
    LandBanner,
    LandSolutionCasePro,
    LandHomePurchase,
    VideoPlay

  },
  data () {
    return {
      architectureUrl: architectureUrl,
      videoList: [],
      videoImg: videoImg1,
      showVideo: false,
      isMask: false,
      playImg,
      value1,
      value2,
      value3,
      value4,
      value5,
      value6,
      bannerUrl,
      bannerTitle: '施工方 数字新成本解决方案',
      bannerText: '解决施工企业成本标准落地难、成本测算效率低、动态成本数据统计难等业务问题，助力企业达成精细化成本管理的目标。'
    }
  },
  methods: {
    onPlay (typeName) {
      this.sentLog(100102005, { type: typeName })
      this.showVideo = true
    },
    // 获取列表
    getList () {
      getVideoList()
        .then(res => {
          const { code, data, message } = res
          if (code === 200) {
            for (let index = 0; index < data.length; index++) {
              if (data[index].clientGroup === '施工方') {
                this.videoList = data[index] || []
              }
            }
          } else {
            this.videoList = []
            message && this.$message.error(message)
          }
        })
        .catch(() => {
          this.videoList = []
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.solution-video {
  height: 737px;
  width: 1200px;
  margin: auto;
  // background: #7aafd2;
  .solution-video-title {
    // height: 56px;
    padding-top: 67px;
    font-size: 40px;
    font-weight: 600;
    color: #181f42;
    line-height: 56px;
    text-align: center;
    margin: 0px auto 18px auto;
  }
  .solution-video-text {
    width: 621px;
    // height: 112px;
    font-size: 16px;
    font-weight: 400;
    color: #5c5c65;
    line-height: 28px;
    text-align: center;
    margin: auto;
  }
  .solution-video-url {
    width: 868px;
    height: 444px;
    // background: #1f1f1f;
    border-radius: 17px;
    // opacity: 0.34;
    margin: 40px auto 0px auto;
    .video-play {
      width: 78px;
      height: 78px;
      background: #ffffff;
      position: relative;
      margin-top: -289px;
      margin-left: 396px;
      z-index: 2;
      border-radius: 50%;
    }
    .video-play:hover {
      cursor: pointer;
    }
  }
}
.solution-architecture {
  height: 943px;
  // width: 1920px;
  width: 100%;
  margin: auto;
  // background: #16405c;
  background: url("../../../../../assets/images/land-page/land-home/construction-bg.png") no-repeat;
  background-size: cover;
  // text-align: center;
  // vertical-align: middle;
  .solution-architecture-title {
    // height: 56px;
    padding-top: 45px;
    font-size: 40px;
    font-weight: 600;
    color: #ffffff;
    line-height: 56px;
    text-align: center;
    margin: 0px auto 29px auto;
  }
  .solution-architecture-img {
    width: 1085px;
    height: 736px;
    // background: #ffffff;
    background-color: #ffffff30;
    border-radius: 10px;
    // opacity: 0.19;
    margin: auto;
    padding: auto;
    display: flex;
    img {
      width: 1085px;
      height: 736px;
      margin: auto;
      //   width: 1085px;
      // height: 813px;
      display: block;
      opacity: 1 !important;
      object-fit: contain;
    }
  }
}
.solution-value {
  height: 778px;
  // width: 1200px;
  margin: auto;
  // width: 1200px;
  // background: #d6d6e3;
  .solution-value-title {
    // height: 56px;
    padding-top: 74px;
    padding-bottom: 42px;
    font-size: 40px;
    font-weight: 600;
    color: #181f42;
    line-height: 56px;
    text-align: center;
    margin: 0px auto 0px auto;
  }
  .solution-value-img {
    width: 1200px;
    // height: 552px;
    // background: #ffffff;
    margin: auto;
    display: flex;
    .value-img-top {
      margin-right: 39px;
      .value-img-title {
        width: 96px;
        height: 96px;
        background: #e8f2ff;
        position: relative;
        z-index: 1;
        margin-left: 87px;
        margin-bottom: -48px;
        border-radius: 50%;
        text-align: center;
      }
      .value-img-text {
        width: 271px;
        height: 148px;
        background: linear-gradient(138deg, #53bbff 0%, #2986ff 100%);
        border-radius: 10px;
        text-align: center;
        font-size: 22px;
        font-weight: 600;
        color: #ffffff;
        line-height: 30px;
      }
    }
  }
  .solution-value-text {
    width: 1200px;
    display: flex;
    margin: auto;
    .value-text {
      width: 581px;
      height: 261px;
      background: #ffffff;
      box-shadow: 0px 3px 8px 4px rgba(0, 0, 0, 0.06);
      border-radius: 10px;
      margin-top: 38px;
      margin-right: 38px;
      display: flex;
      .value-text-left {
        width: 240px;
        img {
          margin-top: 38px;
          margin-left: 49px;
        }
        .text-left {
          width: 120px;
          font-size: 24px;
          font-weight: 600;
          color: #1f1f1f;
          line-height: 33px;
          margin-top: -15px;
          margin-left: 50px;
        }
      }
      .value-text-right {
        width: 341px;
        .text-right-title {
          // width: 288px;
          font-size: 24px;
          font-weight: 600;
          color: #2986ff;
          line-height: 32px;
          margin-top: 50px;
          margin-bottom: 13px;
        }
        .text-right-text {
          width: 296px;
          font-size: 18px;
          font-weight: 400;
          color: #181f42;
          line-height: 26px;
          display: flex;
          ul {
            padding-left: 21px;
            li {
              text-indent: 0px;
              line-height: 29px;
            }
          }
          .point {
            width: 5px;
            height: 5px;
            line-height: 32px;
            background: #181f42;
          }
        }
      }
    }
  }
}
.solution-case {
  height: 740px;
  // width: 1200px;
  margin: auto;
  // background: #1f293b;
}
</style>
